import { render, staticRenderFns } from "./chat1.vue?vue&type=template&id=d37bedd2&"
import script from "./chat1.vue?vue&type=script&lang=js&"
export * from "./chat1.vue?vue&type=script&lang=js&"
import style0 from "./chat1.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports